module.exports = __webpack_public_path__ + "static/media/collection-icon.a67c2a96.svg";